import { render, staticRenderFns } from "./CourseResourceCardList.vue?vue&type=template&id=0c6f274a&scoped=true"
import script from "./CourseResourceCardList.vue?vue&type=script&lang=js"
export * from "./CourseResourceCardList.vue?vue&type=script&lang=js"
import style0 from "./CourseResourceCardList.vue?vue&type=style&index=0&id=0c6f274a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f274a",
  null
  
)

export default component.exports